import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'cart-add_to_cart-click';
/**
 * Send FB Pixel event when user adds to their cart
 */
export function trackCartAddToCartClick(pixelCustomDataParams) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: true,
        facebookPixelEvent: 'AddToCart',
        pixelCustomDataParams: pixelCustomDataParams,
    });
}
